<template>
  <div>
    <vetalfa-dialog
      v-on:dialogClose="close"
      :toggleModel="purchasesModel"
      :smallHeader="false"
      :fullscreen="true"
      :maxWidth="`${width}px`"
      v-if="user"
      contentClasses="purchases-web-position-content"
    >
      <template v-slot:header>
        <v-row class="ma-0 pa-0">
          <v-btn
            v-if="!loading"
            absolute
            @click="setPurchasesModel(false)"
            small
            fab
            elevation="5"
            class="ma-2 pa-0 purchases-close-btn"
          >
            <v-icon color="white" class="ma-0 pa-0">{{ mdiClose }}</v-icon>
          </v-btn>
          <v-img
            class="pa-0 ma-0"
            :src="pro"
            style="z-index: 1"
            height="140"
            :width="width + 10"
          >
            <template v-slot:placeholder>
              <v-row
                color=""
                class="fill-height vetalfa-background ma-0"
                align="center"
                justify="center"
              >
              </v-row>
            </template>
          </v-img>
        </v-row>
      </template>

      <v-row class="ma-0 pa-0 px-6" v-if="metadata">
        <v-row align="start" justify="center" class="ma-0 pa-0 vetalfa-row">
          <v-col
            class="ma-0 pa-0 mt-5 pr-16"
            style="word-break: break-word !important"
            cols="12"
          >
            <p class="ma-0 pa-0 text-left black--text text-h5 font-weight-bold">
              {{ metadata.main_title[_lang()] }}
            </p>
          </v-col>

          <v-col cols="12" class="ma-0 pa-0 mt-4">
            <v-card
              outlined
              v-for="(product, index) in products"
              :key="`available-products-${index}`"
              :class="
                productModel === index
                  ? 'purchases-product-card-selected mb-4'
                  : 'purchases-product-card mb-4'
              "
              elevation="0"
              @click="productModel = index"
            >
              <v-list-item three-line class="ma-0 px-1 py-2">
                <v-list-item-action center>
                  <v-radio-group v-model="productModel">
                    <v-radio color="primary" :value="index"></v-radio>
                  </v-radio-group>
                </v-list-item-action>
                <v-list-item-content class="ma-0 pa-0">
                  <div
                    class="primary--text subtitle-2 font-weight-bold ma-0 pa-0"
                    style="line-height: 16px"
                  >
                    {{ metadata.offers_titles[index][_lang()] }}
                  </div>
                  <div
                    class="caption mb-1 black--text text--darken-3 pr-3"
                    style="line-height: 14px"
                  >
                    {{ metadata.offers_descriptions[index][_lang()] }}
                  </div>
                  <v-list-item-subtitle
                    class="subtitle-2 font-weight-bold black--text mt-1"
                    >{{
                      `${getSubscriptionPrice(product)}/${
                        metadata.offers_periods[index][_lang()]
                      }`
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col cols="12" class="ma-0 pa-0">
            <v-list dense>
              <v-list-item
                v-for="feature in metadata.features"
                :key="feature[_lang()]"
                class="pa-0 ma-0"
                style="height: 30px !important; min-height: 30px !important"
              >
                <v-list-item-icon class="mt-1 ma-0 pa-0">
                  <v-icon size="16" color="primary">{{ mdiCheckBold }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content
                  class="pa-0 ma-0"
                  style="align-self: start !important"
                >
                  <v-list-item-title class="pt-1">
                    {{ feature[_lang()] }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-row>

      <template v-slot:actions>
        <v-col class="ma-0 pa-0 mt-6 pb-4">
          <v-row class="ma-0 pa-0" justify="center">
            <v-btn
              large
              :loading="loading"
              class="text-none white--text px-10"
              color="primary"
              rounded
              @click="purchasesOrderWithCpfConfirmation"
              v-if="products && products.length > 0"
            >
              {{
                `Assinar por ${getSubscriptionPrice(products[productModel])}/${
                  metadata.offers_periods[productModel][_lang()]
                }`
              }}
            </v-btn>
          </v-row>
          <v-row
            class="ma-0 pa-0 pb-2 pt-4 px-6"
            :justify="_isAndroid() ? 'start' : 'center'"
          >
            <span
              class="caption grey--text"
              style="line-height: 14px !important"
            >
              <span v-if="_isAndroid()">{{
                _getLabel("PURCHASES_DISCLAIMER_GOOGLE")
              }}</span>
              <span
                @click="showHowItWorks"
                class="primary--text text-none text-decoration-underline vetalfa-pointer"
              >
                {{ _getLabel("KNOW_MORE") }}
              </span>
            </span>
          </v-row>
        </v-col>
      </template>
    </vetalfa-dialog>
    <vetalfa-update-registration
      v-on:callbackUpdateRegistration="callbackUpdateRegistration"
      successMessage="Sucesso ao atualizar seus dados, estamos te direcionando para o pagamento..."
      :modelTrigger="updateRegistrationModel"
      v-on:closeUpdateRegistrationModel="updateRegistrationModel = false"
    ></vetalfa-update-registration>
  </div>
</template>

<style>
.purchases-web-position-content {
  margin: 0px !important;
  height: 100% !important;
  position: absolute !important;
  right: 0px !important;
}

.purchases-product-card-selected {
  border: 2px solid #193153 !important;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);
  border-radius: 12px !important;
}

.purchases-product-card {
  border: 2px solid #f2f2f2 !important;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);
  border-radius: 12px !important;
}

.purchases-body {
  margin: 0px;
  padding: 24px;
  background: transparent;
  z-index: 2;
  height: 100%;
}

.purchases-close-btn {
  z-index: 1000000;
  top: calc(0px + env(safe-area-inset-top));
  top: calc(0px + constant(safe-area-inset-top));
  background-color: rgba(0, 0, 0, 0.4) !important;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { purchasesOrder } from "@/plugins/purchases.plugins.js";
import { mdiSync, mdiClose, mdiCheckBold } from "@mdi/js";
import images from "@/constants/images.js";
import UpdateRegistration from "@/components/UpdateRegistration.vue";
export default {
  name: "Purchases",
  data() {
    return {
      purchasesOrder,
      mdiClose,
      mdiSync,
      mdiCheckBold,
      pro: images.PRO,
      width: 0,
      updateRegistrationModel: false,
      productModel: 0,
    };
  },
  mounted() {
    this.offsetDialogProportions();
  },
  computed: {
    ...mapGetters("general", ["loading", "user", "isPremium", "toggles"]),
    ...mapGetters("purchases", [
      "products",
      "metadata",
      "purchasesModel",
      "openPurchasesFromMenu",
    ]),
    purchaseData() {
      return this.user.purchaseData;
    },
    featuresNumber() {
      const windowHeight = this._getWindowHeight();
      if (windowHeight > 640) {
        return 4;
      } else if (windowHeight > 575) {
        return 2;
      }
      return 0;
    },
  },
  methods: {
    ...mapActions("general", ["logEvent", "displayHelpArticle"]),
    ...mapMutations("purchases", [
      "setPurchasesModel",
      "setOpenPurchasesFromMenu",
    ]),

    showHowItWorks() {
      this.logEvent("purchases_how_it_works");
      this.displayHelpArticle({
        id: process.env.VUE_APP_FAQ_SUBSCRIPTIONS,
      });
    },

    offsetDialogProportions() {
      this.setPurchasesModel(false);
      this.$nextTick(() => {
        this.width = this._getWindowWidth();
        this.width = this.width > 600 ? 600 : this.width;
      });
    },
    callbackUpdateRegistration() {
      this.updateRegistrationModel = false;
      this.$nextTick(() => {
        this.purchasesOrder(
          this.products ? this.products[this.productModel] : null
        );
      });
    },
    getSubscriptionPrice(pkg) {
      return pkg.product.priceString;
    },

    close() {
      this.setPurchasesModel(false);
    },
    purchasesOrderWithCpfConfirmation() {
      if (!!this.user.cpf || !!this.user.nationality) {
        this.purchasesOrder(
          this.products ? this.products[this.productModel] : null
        );
      } else {
        this.updateRegistrationModel = true;
      }
    },
  },
  watch: {
    "$route.name": {
      handler: function (val) {
        if (val === "checkouts") {
          this.purchasesOrderWithCpfConfirmation();
        }
      },
      deep: true,
      immediate: true,
    },
    openPurchasesFromMenu: {
      handler: function (val) {
        if (val) {
          this.purchasesOrderWithCpfConfirmation();
          this.$nextTick(() => {
            this.setOpenPurchasesFromMenu(false);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    "vetalfa-update-registration": UpdateRegistration,
  },
};
</script>